import { SeuConfigInputItem } from '@seu-types';

export const SEU_COMPONENT_INPUT_PLACEHOLDER = 'input-0';
export const SEU_COMPONENT_OUTPUT_PLACEHOLDER = 'output-0';

export type SeuComponentHandle = {
  id: string;
};

export type SeuComponentSplitterHandleValueBase = {
  unit: string;
  isRemainder: boolean;
  value: number | null;
};

export type SeuComponentSplitterHandleValue =
  SeuComponentSplitterHandleValueBase & {
    operatingConditionId: string;
  };

export type SeuComponentSplitterHandle = SeuComponentHandle & {
  values: SeuComponentSplitterHandleValue[];
};

export type SeuComponentBase = {
  name: string;
  componentType: string;
  inputs: SeuConfigInputItem[];
  inputHandles: SeuComponentHandle[];
  outputHandles: SeuComponentSplitterHandle[];
};

export type SeuComponent = SeuComponentBase & {
  id: string;
};

export type SeuComponentSplitterHandleValueApi =
  SeuComponentSplitterHandleValueBase & {
    operatingConditionId: number;
  };

export type SeuComponentSplitterHandleApi = SeuComponentHandle & {
  values: SeuComponentSplitterHandleValueApi[];
};

export type SeuComponentBaseApi = {
  name: string;
  componentType: string;
  inputs: SeuConfigInputItem[];
  inputHandles?: SeuComponentHandle[];
  outputHandles?: SeuComponentSplitterHandleApi[];
};

export type SeuComponentApi = SeuComponentBaseApi & {
  id: number;
};

export type SeuComponentLibraryCategory = {
  name: string;
  items: SeuComponentLibraryCategoryItem[];
};

export type SeuComponentLibraryCategoryItem = {
  svg: string;
  label: string;
  componentType: string;
  synonyms: string[];
};
